import { useQuery } from 'react-query';

import { getQRCode as queryFn } from 'api/endPoints/getQRCode';

export const useQueryGetQRCode = (params) => {
    return useQuery(['getQRCode', params], () => queryFn(params), {
        enabled: Boolean(params.email),
    });
};
